import React, { useState, lazy } from 'react'
import { Route } from 'react-router-dom';
import * as PageUrl from '../utils/pageUrl'
import TopNav from '../components/DashNav/TopNav';
import Loader from '../components/Loader';
import { Modal } from '../useStyles';
// import SideNav from '../components/Navigation/SideNav';
import ProNav from '../components/DashNav/ProNav';
import VerifyEmail from '../components/VerifyEmail';
// import ProtectedRoute from './protectedRoute';
// import LogoutPopup from '../utils/timeoutLogout';


function Routes() {
  const [collapsed, setCollapsed] = useState(false);
  const [toggled, setToggled] = useState(false);

  const handleCollapsedChange = (checked) => {
    setCollapsed(checked);
  };

  const handleToggleSidebar = (value) => {
    // console.log(value);
    setToggled(value);
  };

  const DashboardUser = lazy(() => import('../routes/Dashboard/UserLogginHome'));
  const Profile = lazy(() => import('../routes/Dashboard/Profile'));
  const ConfirmEmail = lazy(() => import('../routes/Dashboard/ConfirmEmail'));
  const Transactions = lazy(() => import('../routes/Dashboard/Transactions'));
  const Transaction = lazy(() => import("../routes/Transaction"));
  const Success = lazy(() => import("../routes/Success"));
  // const SellCoin = lazy(() => import("../routes/Sell/Sellcoin"));
  const TheModal = lazy(() => import("../routes/Sell/TheModal"));
  const Sell = lazy(() => import("../routes/Sell"));

  return (
    <div className={`flex  ${toggled ? 'toggled' : ''}`}>
      <React.Suspense fallback={
        <Modal className="grid place-items-center h-screen z-50"  >
          <Loader />
        </Modal>
      }>
        {/* <div className="max-h-screen "> */}
        <ProNav
          collapsed={collapsed}
          toggled={toggled}
          handleToggleSidebar={handleToggleSidebar} />
        {/* <LogoutPopup /> */}

        {/* </div> */}
        <div className=" w-full m-auto bg-blue-new  relative min-h-screen h-full flex flex-col justify-between">

          <TopNav
            toggled={toggled}
            collapsed={collapsed}
            handleToggleSidebar={handleToggleSidebar}
            handleCollapsedChange={handleCollapsedChange}
          />

          <div className=" h-full pt-28 pb-10 px-4 lg:px-20 container mx-auto " style={{ backgroundColor: "#fff" }}>
            {/* <button onClick={goBack}
                className="mb-3 grid gap-2 place-items-center grid-flow-col px-4 py-2.5"
              >
                <IoMdArrowRoundBack />
                Back</button> */}
            <VerifyEmail />
            <Route exact path={PageUrl.DASHBOARD} component={DashboardUser} />
            <Route exact path={PageUrl.PROFILE} component={Profile} />
            <Route exact path={PageUrl.VERIFY_EMAIL} component={ConfirmEmail} />
            <Route exact path={PageUrl.TRANSACTIONS} component={Transactions} />
            <Route exact path={PageUrl.TRANSACTION} component={Transaction} />
            <Route exact path={PageUrl.SELL} component={Sell} />

            <Route exact path={PageUrl.SUCCESS} component={Success} />
            {/* <Route exact path={PageUrl.SELL_COIN} component={SellCoin} /> */}
            <Route exact path={PageUrl.SELL_COIN_REFERENCE} component={TheModal} />
    
          </div>
          <footer className='px-4 md:px-8 lg:px-20 py-7 border-t w-full'>
            &copy; 2022. Redimit
          </footer>
          
        </div>
      </React.Suspense>
      {/* </Errorpage> */}
    </div>
  )
}

export default Routes